import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface LessonsDemoState {
    items: TestData[];
}

const initialState: LessonsDemoState = {
    items: [],
};

const lessonsTestAllowedSlice = createSlice({
    name: "lessons/testAllowed",
    initialState,
    reducers: {
        setLessonsTestAllowed: (state, action:PayloadAction<LessonsDemoState>) => {
            const {items} = action.payload;
            state.items = items;
        },
    },

});


export const {
    setLessonsTestAllowed,
} = lessonsTestAllowedSlice.actions;
export const lessonsTestAllowedReducer = lessonsTestAllowedSlice.reducer;